import { ChakraProvider } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import { ColorModeProvider } from './color-mode'
import { system } from './theme'

/**
 * Wraps the app in Chakra's system and colour-mode handling.
 *
 * Colour mode is handled in-house rather than by next-themes: next-themes
 * exists to prevent an SSR flash and always renders an inline <script>, which
 * a client-rendered SPA never executes — React logs an error and the flash is
 * not prevented. The bootstrap script in index.html does that job properly.
 */
export function Provider({ children }: { children: ReactNode }) {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider>{children}</ColorModeProvider>
    </ChakraProvider>
  )
}
